<template>
    <div>
        <span v-if="voucher.usr_revoke">
            Revoked manually
        </span>
        <span v-else-if="voucher.cron_revoke">
            Revoked Automatically (defined by policy rules)
        </span>
        <span v-else>
            <button class="btn" @click="revokeVoucher()">Revoke</button>
            <button class="btn"
                :disabled="voucher.used == 1"
                @click="discountVoucher()">
                    Discount
            </button>
        </span>
    </div>
</template>

<script>
export default {
    props: ['voucher'],
    data () {
        return {
            error: null
        }
    },
    watch: {
        error: function(val) {
            this.processErrors(val)
        }
    },
    methods: {

        // mark voucher as revoked by User
        revokeVoucher () {
            this.error = null

            let message = prompt("Reason:")
            if (message === null)
                return

            this.api().put('voucher/edit', {
                id: this.voucher.id,
                usr_revoke: true,
                usr_obs: message
            })
                .then(({data}) => {
                    this.voucher.revoked = true
                    this.voucher.usr_revoke = true
                })
                .catch(({response}) => {
                    this.error = response.data.response[0]
                })
        },

        // mark voucher as used
        discountVoucher () {
            this.error = null

            this.$swal({
                title: 'Are you sure?',
                text: "Mark this voucher as used?",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'OK',
                focusCancel: true
            }).then((result) => {
                if (result.value) {
                    this.api().put('voucher/edit', {
                        id: this.voucher.id,
                        used: 1
                    })
                    .then(({data}) => {
                        this.voucher.used = 1
                    })
                    .catch(({response}) => {
                        this.error = response.data.response[0]
                    })
                }
            })
        },

        processErrors (errors) {
            this.$emit('onError', errors)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/vouchers/plugins/Actions.vue